import {api} from './api';
import { User } from '../model/user';
import { UserRole } from '../auth/jwt';

export const getUser = async (accessToken: string, userId: string): Promise<User> => {
    const response = await api.get<User>(`/users/${userId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    })

    return response.data as User
}

export const getUsers = async (accessToken: string): Promise<User[]> => {
    const response = await api.get<User[]>(`/users`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.data as User[]
}

export const addUsers = async (accessToken: string, emails: string[]): Promise<User[]> => {
    const response = await api.post(`/users`, emails, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.data as User[]
}

export const deleteUser = async (accessToken: string, userId: string): Promise<boolean> => {
    const response = await api.delete(`/users/${userId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    })

    return response.status == 204 || response.status == 200
}

export const getRoleUsers = async (accessToken: string, role: UserRole): Promise<User[]> => {
    const response = await api.get(`/roles/${role.toString()}/users`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data as User[]
};

export const grantUserRole = async (accessToken: string, userId: string, role: UserRole): Promise<boolean> => {
    const response = await api.post(`/users/${userId}/roles/${role.toString()}`, {
        // empty body
    }, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.status === 200;
};

export const removeUserRole = async (accessToken: string, userId: string, role: UserRole): Promise<boolean> => {
    const response = await api.delete(`/users/${userId}/roles/${role.toString()}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.status === 200;
};